module.exports = __webpack_public_path__ + "img/ch_gallery_3.77602b08.jpg";